import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { BankAccountInstructionClient } from "../../../../../../../Wrap/Api/BankAccounts/BankAccountInstruction";
import { DocumentTaskRequestTypeEnum } from "../../../../../../../Wrap/Constants/Enums/Tasks/DocumentTaskRequestTypeEnum";
import { BankAccountInstruction } from "../../../../../../../Wrap/Models/Domains/Instructions/BankAccountInstruction";
import { DocumentTaskRequestModel } from "../../../../../../../Wrap/Models/Models/Tasks/DocumentTaskRequestModel";
import { DownloadButtonAction } from "../../../../../../Shared/DownloadButton/Actions/DownloadButtonAction";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentsHelper } from "../../../PortfolioDashboard/Components/Document/Resource/DocumentsHelper";
import { processTypeEnum } from "../../Resource/Contents";

export class BankAccountAction {
    public static saveBankInstruction(
        bankAccountInstruction: BankAccountInstruction,
        customerId?: number,
        processType?: processTypeEnum,
        callBack?: (val: BankAccountInstruction) => void
    ): void {
        const params = getQueryParameters();
        const customerid = customerId ? customerId.toString() : params["customerid"];
        const claccountid = params["claccountid"];
        const instructionId = params["id"];
        const headAccountHierarchyId = params["hierarchyid"];
        const client = new BankAccountInstructionClient();
        const promise = client.post(bankAccountInstruction);
        const query = DocumentsHelper.getTaskRequest(
            instructionId,
            customerid,
            claccountid,
            headAccountHierarchyId,
            DocumentTaskRequestTypeEnum.BankDetailsChange,
            processType
        );
        if (!CommonHelper.isNullOrEmpty(customerid) && !CommonHelper.isNullOrEmpty(claccountid)) {
            DownloadButtonAction.addTaskRequestForDocument(query, (callback) => {});
        }

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });

        promise.onError((err) => {});
    }

    public static removeBankInstruction(bankAccountInstruction: BankAccountInstruction, callBack?: () => void): void {
        const client = new BankAccountInstructionClient();
        const promise = client.delete(bankAccountInstruction);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack();
            }
        });

        promise.onError((err) => {});
    }
}
